import React, { Component } from "react";
import Styled from "styled-components";

import chat from "../assets/chattish.png";
import foto from "../assets/fotocoment.png"
import Badges from "./Badges";

class Projects extends Component {
  constructor() {
    super();
    this.state = {
      react: { icon: <i className="fab fa-react" />, color: "#53D2F9" },
      socketio: { icon: <i className="icon-socketio" />, color: "#000000" },
      aws: { icon: <i className="fab fa-aws" />, color: "#E67E24" },
      rethinkdb: { icon: <i className="icon-rethinkdb" />, color: "#193C46" },
      heroku: { icon: < i className="icon-heroku" />, color: "#9E7BC2" },
      ruby: { icon: < i className="icon-ruby" />, color: "#9A1D16" },
      rails: { icon: < i className="icon-rails" />, color: "#CC0200" },
      postgresql: { icon: < i className="icon-postgresql" />, color: "#336691" }
    };
  }
  render() {
    const Container = Styled.div`
        display: flex;
        flex-direction: column;
        width: 100vw;
        justify-content: space-around;
        align-items: center;
        border-bottom: 5px solid Tomato;

        @media (max-width: 700px) {
          flex-direction: column;
          justify-content: space-between;
			}
        `;

    const Div = Styled.div`
    width: 75vw;
    display: inline-flex;
    align-items: center;
    justify-content: space-between;
    border-top: 5px solid Tomato;

        @media (max-width: 900px) {
            flex-direction: column;
            justify-content: center;
            align-content: center;
        }
    `;

    const P = Styled.p`
    box-sizing: border-box;
    margin: auto;
    letter-spacing: 2px;
    line-height: 1.6;
    text-align: left;
    word-wrap: break-word;
    transition: all .8s ease-in-out;
    -webkit-transition: all .8s ease-in-out;
    -moz-transition: all .8s ease-in-out;

        `;

    const Img = Styled.img`
    transition: all .8s ease-in-out;
    -webkit-transition: all .8s ease-in-out;
    -moz-transition: all .8s ease-in-out;
        -webkit-box-shadow:0 19px 38px rgba(0,0,0,0.30), 0 15px 12px rgba(0,0,0,0.22);
        -moz-box-shadow:0 19px 38px rgba(0,0,0,0.30), 0 15px 12px rgba(0,0,0,0.22);
        box-shadow: 0 19px 38px rgba(0,0,0,0.30), 0 15px 12px rgba(0,0,0,0.22);
        width: 350px;
        margin: 20px;
        
       
        @media (max-width: 900px) {
            margin-bottom: 50px;
            width: 250px;
        }
       
       @media (max-width: 700px) {
          margin-bottom: 25px;
            width: 150px;
        }
        `;

    const Button = Styled.a`
            background-color: rgba(255, 80, 53, 0.901961);
            border-radius: 3px;
            color: #fff;
            height: 64px;
            cursor: pointer;
            display: inline-block;
            padding: 20px;
            box-sizing: border-box;
            line-height: 24px;
            text-decoration: none;
            text-align: center;
            text-shadow: rgba(0, 0, 0, 0.270588) 0px 1px 0px;
            text-size-adjust: 100%;
            font-size: 1.5em;
            margin: 5px;
            transition: all .8s ease-in-out;
            -webkit-transition: all .8s ease-in-out;
            -moz-transition: all .8s ease-in-out;

            &:hover {
                background-color: #27ae60;
            }
            
            &:active {
                background-color: #19da6a;  
            } 

            @media (max-width: 700px) {
                height: 32px;
                display: block;
                padding: 5px;
                line-height: 12px;

            }

        `;

    const Techs = Styled.div`
    display: block;
    margin: 20px;

  @media (max-width: 1025px) {
    display: inline-block;
    margin: 5px;
}
            
        `;

    return (
      <Container>
        <Div>
          <Img src={chat} />
          <Techs>
            <Badges
              badge={this.state.react.icon}
              color={this.state.react.color}
            />
            <Badges
              badge={this.state.socketio.icon}
              color={this.state.socketio.color}
            />
            <Badges
              badge={this.state.rethinkdb.icon}
              color={this.state.rethinkdb.color}
            />
            <Badges badge={this.state.aws.icon} color={this.state.aws.color} />
          </Techs>
          <P>
            <em>Chattish</em> it's a web application where users are able to
            create channels and start chatting with a custom username or remain
            anonymous.
            <br /> <br />
            <Button
              href="https://github.com/che-perez/chattish"
              target="_blank"
            >
              <i className="fab fa-github-alt" /> GitHub
            </Button>
            <Button
              href="http://ec2-54-227-230-53.compute-1.amazonaws.com/"
              target="_blank"
            >
              <i className="fas fa-external-link-alt" /> Live
            </Button>
          </P>
        </Div>
        <Div>
          <Img src={foto} />
          <Techs>
            <Badges
              badge={this.state.ruby.icon}
              color={this.state.ruby.color}
            />
            <Badges
              badge={this.state.rails.icon}
              color={this.state.rails.color}
            />
            <Badges
              badge={this.state.postgresql.icon}
              color={this.state.postgresql.color}
            />
            <Badges badge={this.state.heroku.icon} color={this.state.heroku.color} />
          </Techs>
          <P>
            <em>FotoComment</em> it's a simple web application where users can share
             photos and leave a comment on other users photos.
            <br /> <br />
            <Button
              href="https://github.com/che-perez/FotoComment"
              target="_blank"
            >
              <i className="fab fa-github-alt" /> GitHub
            </Button>
            <Button
              href="https://foto-comment.herokuapp.com/"
              target="_blank"
            >
              <i className="fas fa-external-link-alt" /> Live
            </Button>
          </P>
        </Div>
      </Container>
    );
  }
}

export default Projects;


// WEBPACK FOOTER //
// ./src/Components/Projects.jsx